<template>
  <topic-view></topic-view>
</template>

<script>
window.location.href = "/";
  import TopicView from "../components/TopicView";
  export default {
    name: "Social",
    components: {TopicView}
  }
</script>

<style scoped>

</style>
